/**
 * @generated SignedSource<<4777eee4ca5de247327d5adc07d1486e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNovaAgentCategoryInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteNovaAgentCategoryMutation$variables = {
  input: DeleteNovaAgentCategoryInput;
};
export type DeleteNovaAgentCategoryMutation$data = {
  readonly deleteNovaAgentCategory: {
    readonly deletedCategoryId: string;
    readonly reassignedAgentCount: number;
  } | null;
};
export type DeleteNovaAgentCategoryMutation = {
  variables: DeleteNovaAgentCategoryMutation$variables;
  response: DeleteNovaAgentCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteNovaAgentCategoryPayload",
    "kind": "LinkedField",
    "name": "deleteNovaAgentCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedCategoryId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reassignedAgentCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteNovaAgentCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteNovaAgentCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "176eb3b05bff555dce78a88967e6edef",
    "id": null,
    "metadata": {},
    "name": "DeleteNovaAgentCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteNovaAgentCategoryMutation(\n  $input: DeleteNovaAgentCategoryInput!\n) {\n  deleteNovaAgentCategory(input: $input) {\n    deletedCategoryId\n    reassignedAgentCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a7527f2980cfa923188ce2fbca3dfcc";

export default node;
